module.exports = __webpack_public_path__ + "media/images/themes/pink_softness/main_bg2-7fcdc3ba2e6d19db79b6cfd451cc3a44.png";